import { render, staticRenderFns } from "./PropertyDetailsLayout.vue?vue&type=template&id=46532b63&scoped=true"
import script from "./PropertyDetailsLayout.vue?vue&type=script&lang=js"
export * from "./PropertyDetailsLayout.vue?vue&type=script&lang=js"
import style0 from "./PropertyDetailsLayout.vue?vue&type=style&index=0&id=46532b63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46532b63",
  null
  
)

export default component.exports